// artistManagement.js

const artistManagement = {
  id: 12,
  title: "Artist Management",
  questions: [
    {
      question: "Do you arrange celebrity or artist bookings?",
      answer:
        "Yes, we manage artist bookings, celebrity appearances, DJs, singers, and performers.",
    },
    {
      question: "Can you manage backstage coordination?",
      answer:
        "Yes, we handle backstage management, artist hospitality, and technical coordination.",
    },
    {
      question: "Do you arrange live performances?",
      answer:
        "Yes, live concerts, performances, and entertainment shows can be organized.",
    },
  ],
};

export default artistManagement;